export default function useReorderSections(){

    return (sections) => {

        const sortKey = s => {
            let rankStr = "00000000" + Math.round(s.rank * 10);
            return s.chapter.id + rankStr.substring(rankStr.length - 6);
        }

        let r = 0; let chapterID = '';
        
        let newSections = [...sections]
            .sort((a,b) => sortKey(a) > sortKey(b) ? 1 : -1)
            .map(s => {
                if(s.chapter.id !== chapterID){
                    r = 0;
                    chapterID = s.chapter.id;
                }
                r++;
                return {...s, rank: r}
            })

        return newSections;
    }
}